import type { ReactNode } from "react";
import { ApogeuLogo } from "./ApogeuLogo";

interface AuthLayoutProps {
  readonly title: string;
  readonly subtitle: string;
  readonly children: ReactNode;
  readonly footer?: ReactNode;
}

export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
  return (
    <div className="auth-screen auth-screen--dark">
      <div className="auth-screen__brand">
        <div className="brand-tile">
          <ApogeuLogo width={48} />
        </div>
        <span className="auth-screen__wordmark">APOGEU</span>
      </div>
      <div className="auth-screen__content">
        <span className="auth-screen__eyebrow">ÁREA DO ALUNO E PROFESSOR</span>
        <h1 className="auth-screen__title">{title}</h1>
        <p className="auth-screen__subtitle">{subtitle}</p>
        {children}
      </div>
      {footer && <div className="auth-screen__footer">{footer}</div>}
    </div>
  );
}
